var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.type === "chat"
    ? _c(
        "div",
        {
          staticClass: "toast-container",
          on: { touchstart: _vm.onStartScroll, click: _vm.onClick },
        },
        [
          _c("img", {
            staticClass: "user-image",
            attrs: { src: _vm.userImage, alt: "유저" },
          }),
          _c("div", { staticClass: "toast-chat-message-container" }, [
            _c("div", { staticClass: "user-name" }, [
              _vm._v(_vm._s(_vm.username)),
            ]),
            _c("div", { staticClass: "message" }, [
              _vm._v(_vm._s(_vm.content)),
            ]),
          ]),
          _c("div", {
            staticClass: "close-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.onClose.apply(null, arguments)
              },
            },
          }),
        ]
      )
    : _c(
        "div",
        {
          staticClass: "toast-container",
          class: { isOpenControlMenu: _vm.isOpenControlMenu },
          on: { touchstart: _vm.onStartScroll },
        },
        [
          _c("div", { staticClass: "toast-icon", class: _vm.type }),
          _c("div", { staticClass: "toast-chat-message-container" }, [
            _c("div", { staticClass: "message" }, [
              _vm._v(_vm._s(_vm.message)),
            ]),
            _vm.content
              ? _c("div", { staticClass: "toast-content" }, [
                  _vm._v(_vm._s(_vm.content)),
                ])
              : _vm._e(),
          ]),
          _c("div", {
            staticClass: "close-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.onClose.apply(null, arguments)
              },
            },
          }),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }